import { render, staticRenderFns } from "./Type10.vue?vue&type=template&id=ce1b8eb4&scoped=true"
import script from "./Type10.vue?vue&type=script&lang=js"
export * from "./Type10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1b8eb4",
  null
  
)

export default component.exports